import type { ModelAddButtonOptions } from "@/modules/model-add-button";

import AssetTypeForm from "@/features/AssetTypes/AssetTypeForm";
import ModelAddButton from "@/modules/model-add-button";

const AssetTypeAddButton = (options: ModelAddButtonOptions) => {
  return (
    <ModelAddButton
      model="assettype"
      component={<AssetTypeForm />}
      {...options}
    />
  );
};

export default AssetTypeAddButton;
